// #region IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { OfflineImportButton } from './OfflineImportButton';
// CSS
import './OfflineImportTab.css';
// #endregion

// #region COMPONENT
/**
 * Import data tab of the settings modal: the import trigger on the study list,
 * a hint to go back to it elsewhere.
 * @param {object} props
 * @param {function} props.onClose Closes the modal once the import starts
 * @returns {JSX.Element} The tab content
 */
export const OfflineImportTab = ({ onClose }) => {
  // #region INITIALIZATION
  const location = useLocation();
  const [t] = useTranslation('StudyList');
  // #endregion

  // #region INTERFACE
  if (location.pathname !== '/') {
    return <p>{t('Go back to the study list to import data.')}</p>;
  }

  return (
    <div className="OfflineImportTab-root">
      <OfflineImportButton
        className="OfflineImportButton-outlined"
        onImportStart={onClose}
      />
    </div>
  );
  // #endregion
};

OfflineImportTab.propTypes = {
  onClose: PropTypes.func,
};
// #endregion
